module.exports = __webpack_public_path__ + "img/timer.002334d0.svg";